import { useState, useEffect } from "react";
import api from "@/lib/api";
import CrudTable from "@/components/CrudTable";
import { inr, pct } from "@/lib/format";
import { Trophy } from "lucide-react";

export default function DepartmentExpense() {
  const [depts, setDepts] = useState(["Clinic-Delhi", "Clinic-Mathura", "Clinic-Jaipur", "Institute", "Marketing", "HR", "Procurement", "IT", "Field Marketing", "E-commerce"]);
  useEffect(() => {
    api.get("/settings").then((r) => { if (r.data?.department_lines?.length) setDepts(r.data.department_lines); }).catch(() => {});
  }, []);

  const columns = [
    { key: "month", label: "Month" },
    { key: "department", label: "Dept / Service / Product" },
    { key: "income", label: "Income", type: "currency" },
    { key: "expense", label: "Expense", type: "currency" },
    { key: "profit", label: "Profit", type: "signed" },
    { key: "profitability_pct", label: "Profitability", type: "percent" },
    { key: "remarks", label: "Remarks" },
  ];
  const fields = [
    { key: "month", label: "Month (YYYY-MM)", type: "text", required: true },
    { key: "department", label: "Department / Service / Product", type: "select", options: depts, required: true },
    { key: "income", label: "Income (₹)", type: "number", required: true },
    { key: "expense", label: "Expense (₹)", type: "number", required: true },
    { key: "remarks", label: "Remarks", type: "textarea", full: true },
  ];

  const renderTop = (rows) => {
    const months = [...new Set(rows.map((r) => r.month))].sort();
    const latest = months[months.length - 1];
    const ranked = rows.filter((r) => r.month === latest).sort((a, b) => b.profit - a.profit);
    const max = Math.max(...ranked.map((r) => Math.abs(r.profit)), 1);
    return (
      <div>
        <div className="flex items-center gap-2 mb-3"><Trophy className="h-4 w-4 text-[#C9A24B]" /><h3 className="font-heading font-medium">Profitability Ranking — {latest || "—"}</h3></div>
        <div className="rounded-xl border border-[#334155] bg-[#1E293B] p-5 space-y-3" data-testid="profitability-ranking">
          {ranked.map((r, i) => (
            <div key={r.id} className="flex items-center gap-3">
              <span className="w-6 text-sm text-slate-500 tabular-nums">#{i + 1}</span>
              <span className="w-40 text-sm truncate">{r.department}</span>
              <div className="flex-1 h-6 rounded bg-[#0F172A] overflow-hidden">
                <div className="h-full rounded" style={{ width: `${(Math.abs(r.profit) / max) * 100}%`, background: r.profit >= 0 ? "#059669" : "#DC2626" }} />
              </div>
              <span className="w-28 text-right text-sm tabular-nums">{inr(r.profit)}</span>
              <span className="w-16 text-right text-sm tabular-nums text-slate-400">{pct(r.profitability_pct)}</span>
            </div>
          ))}
          {ranked.length === 0 && <p className="text-sm text-slate-500">Add records to see the profitability ranking.</p>}
        </div>
      </div>
    );
  };

  return (
    <CrudTable
      testid="dept" endpoint="dept-expense"
      title="Department / Service / Product Expense" subtitle="Answers 'which service or product is actually making us money' — Profit and Profitability % are auto-calculated and feed the Dashboard and Budgeting decisions."
      addLabel="Add Line Item" columns={columns} fields={fields} renderTop={renderTop}
    />
  );
}
